import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import EChallanCommonReasonsV2 from "../e-challan-common-reasons-v2";
import EChallanStates from "../e-challan-states";
import EChallanBreadCrumb from "../../shared/e-challan-breadcrumb";
import EChallanTestimonials from "../e-challan-testimonials";
import { sendCustomGaEvents } from "../../../tracking";
import EChallanHeroBannerV2 from "../e-challan-hero-banner-v2";
import WhyPayChallans from "../e-challan-why-pay-challans";
import EChallanTrustFactors from "../e-challan-trust-factors";
import EChallanEasySteps from "../e-challan-easy-steps";
import EChallanFaqsVariant from "../e-challan-faq-variant";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";
import EChallanRecentTransaction from "../e-challan-recent-transaction";
import useC2bCleverTap from "../../../hooks/use-c2b-clevertap";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { challanPageLoad } from "./tracking";
import { CHALLAN_PAGE_TYPE } from "../../../constants/challan-constants";
import { appUrl } from "../../../constants/url-constants";
import loadable from "@loadable/component";
const AdsComponent = loadable(() => import("../../shared/ads"));
import { LazyComponent } from "../../shared/lazy-image";

const EChallan = ({
    source,
    setGaSourceConnect,
    cmsContent = null,
    isSSR = false,
    fetchChallanLandingPageDataConnect = () => {},
    regNumberList,
    recentTransaction,
    isLoggedIn,
    secureToken,
    pageType,
    fetchRegNumberListConnect,
    fetchOrderDataConnect
}) => {
    useC2bCleverTap("Pay_challan");

    useEffect(() => {
        if (source) {
            sendCustomGaEvents({us_vas_page_source: source});
            setGaSourceConnect(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source]);

    useEffect(() => {
        if (isLoggedIn) {
            if (!isSSR) {
                fetchRegNumberListConnect(secureToken);
            }
            if (!recentTransaction || !isSSR) {
                fetchOrderDataConnect(secureToken);
            }
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [isLoggedIn]);

    const {
        heroBannerData = {},
        whyPayChallanData = {},
        whatIsChallanData = {},
        whyChallanIssueData = {},
        challanTestimonialsData = {},
        challanStateListData = {},
        challanFaqData = {},
        howToPayChallanData = {},
        trustChallanData = {}
    } = cmsContent || {};

    useEffect(() => {
        if (!isSSR && (!isObjectEmpty(cmsContent) || pageType === CHALLAN_PAGE_TYPE.STATE_CHALLAN)) {
            fetchChallanLandingPageDataConnect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    useEffect(() => {
        const handleTrackPageLoad = async () => {
            await yieldToMain();
            sendCustomGaEvents(challanPageLoad);
        };

        handleTrackPageLoad();
    }, []);

    return (
        <React.Fragment>
            <EChallanHeroBannerV2 heroBannerData={heroBannerData} regNumberList={regNumberList} />
            {!!recentTransaction && <EChallanRecentTransaction orderData={recentTransaction} />}
            <EChallanEasySteps howToPayChallanData={howToPayChallanData} />
            <div styleName="styles.adsContainerInPage">
                <LazyComponent>
                    <AdsComponent
                        slotName="challan_DESKTOP_above-trusted-by_mid_leaderboard_970x90"
                        platformType="DESKTOP"
                        bu="challan"
                        url={`${appUrl()}/traffic-challan/`}
                        height={90}
                        width={970}
                    />
                </LazyComponent>
            </div>
            <EChallanTrustFactors trustChallanData={trustChallanData} />
            <WhyPayChallans whyPayChallanData={whyPayChallanData} />
            <EChallanCommonReasonsV2 whatIsChallanData={whatIsChallanData} whyChallanIssueData={whyChallanIssueData} />
            <EChallanTestimonials challanTestimonialsData={challanTestimonialsData} />
            <div styleName={"styles.eChallanStateWrapper"}>
                <EChallanStates title={challanStateListData?.title} isChallanRevamped />
            </div>
            <EChallanFaqsVariant challanFaqData={challanFaqData} />
            <EChallanBreadCrumb />

        </React.Fragment>
    );
};

EChallan.propTypes = {
    source: PropTypes.string,
    setGaSourceConnect: PropTypes.func,
    cmsContent: PropTypes.object,
    isSSR: PropTypes.bool,
    fetchChallanLandingPageDataConnect: PropTypes.func,
    regNumberList: PropTypes.array,
    recentTransaction: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    secureToken: PropTypes.string,
    pageType: PropTypes.string,
    fetchRegNumberListConnect: PropTypes.func,
    fetchOrderDataConnect: PropTypes.func
};

export default EChallan;
